export default "__VITE_ASSET__Ba8EXQl6__"